import React from "react";
import "./footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      Copyright &#169; 2026 Sheikh Awab. All right received.
    </footer>
  );
};

export default Footer;
